import { render } from "./Features.vue?vue&type=template&id=6a0fa492&scoped=true"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"

import "./Features.vue?vue&type=style&index=0&id=6a0fa492&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a0fa492"

export default script